import { Glyph } from '@visx/glyph';

type GlyphProps = {
  left: number;
  top: number;
};
const RainGlyph = ({ left, top }: GlyphProps) => {
  return (
    <Glyph left={left} top={top}>
      <svg width="28" height="26" viewBox="0 0 28 26" fill="none">
        <path
          d="M20.9002 14.6933H26.3754C26.415 14.4594 26.4348 14.2181 26.4348 13.9717C26.4348 11.5984 24.5438 9.67509 22.2103 9.67509C21.9705 9.67509 21.7357 9.69521 21.5083 9.73543C20.7643 7.86745 18.9647 6.55006 16.8612 6.55006C16.389 6.55006 15.9317 6.61794 15.4992 6.74113C15.1976 4.21696 13.0866 2.26099 10.5233 2.26099C7.75477 2.26099 5.5103 4.5438 5.5103 7.3596C5.5103 7.62358 5.53008 7.88253 5.56716 8.13395C3.30786 8.44067 1.56519 10.4067 1.56519 12.7876C1.56519 13.4664 1.70855 14.1125 1.96316 14.6958H7.16399"
          fill="#E5E9F2"
        />
        <path
          d="M20.9002 13.6933C20.3479 13.6933 19.9002 14.141 19.9002 14.6933C19.9002 15.2455 20.3479 15.6933 20.9002 15.6933V13.6933ZM26.3754 14.6933V15.6933C26.8634 15.6933 27.28 15.3411 27.3614 14.86L26.3754 14.6933ZM21.5083 9.73543L20.5793 10.1055L20.8806 10.862L21.6825 10.7201L21.5083 9.73543ZM15.4992 6.74113L14.5062 6.85976L14.6453 8.02405L15.7731 7.70289L15.4992 6.74113ZM5.56716 8.13395L5.70168 9.12486L6.70404 8.98878L6.55646 7.98804L5.56716 8.13395ZM1.96316 14.6958L1.04667 15.0958C1.20573 15.4602 1.56556 15.6958 1.96316 15.6958V14.6958ZM7.16399 15.6958C7.71627 15.6958 8.16399 15.2481 8.16399 14.6958C8.16399 14.1435 7.71627 13.6958 7.16399 13.6958V15.6958ZM20.9002 15.6933H26.3754V13.6933H20.9002V15.6933ZM27.3614 14.86C27.4107 14.5687 27.4348 14.2715 27.4348 13.9717H25.4348C25.4348 14.1647 25.4193 14.3501 25.3894 14.5265L27.3614 14.86ZM27.4348 13.9717C27.4348 11.0621 25.112 8.67509 22.2103 8.67509V10.6751C23.9756 10.6751 25.4348 12.1346 25.4348 13.9717H27.4348ZM22.2103 8.67509C21.9147 8.67509 21.6215 8.69989 21.3341 8.75072L21.6825 10.7201C21.8499 10.6905 22.0264 10.6751 22.2103 10.6751V8.67509ZM22.4373 9.3654C21.5501 7.13794 19.3962 5.55006 16.8612 5.55006V7.55006C18.5333 7.55006 19.9784 8.59696 20.5793 10.1055L22.4373 9.3654ZM16.8612 5.55006C16.2929 5.55006 15.7434 5.6318 15.2253 5.77937L15.7731 7.70289C16.12 7.60407 16.4852 7.55006 16.8612 7.55006V5.55006ZM16.4921 6.6225C16.1329 3.61577 13.6131 1.26099 10.5233 1.26099V3.26099C12.5601 3.26099 14.2623 4.81816 14.5062 6.85976L16.4921 6.6225ZM10.5233 1.26099C7.18658 1.26099 4.5103 4.00755 4.5103 7.3596H6.5103C6.5103 5.08004 8.32296 3.26099 10.5233 3.26099V1.26099ZM4.5103 7.3596C4.5103 7.67349 4.53381 7.98121 4.57786 8.27985L6.55646 7.98804C6.52634 7.78386 6.5103 7.57367 6.5103 7.3596H4.5103ZM5.43263 7.14304C2.67201 7.51782 0.565186 9.91205 0.565186 12.7876H2.56519C2.56519 10.9013 3.94371 9.36352 5.70168 9.12486L5.43263 7.14304ZM0.565186 12.7876C0.565186 13.6082 0.738659 14.3902 1.04667 15.0958L2.87965 14.2957C2.67845 13.8348 2.56519 13.3246 2.56519 12.7876H0.565186ZM1.96316 15.6958H7.16399V13.6958H1.96316V15.6958Z"
          fill="#0C4261"
        />
        <path
          d="M10.0407 12.7173L6.83594 23.739"
          stroke="#0C4261"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M19.2761 12.7173L16.0713 23.739"
          stroke="#0C4261"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M14.6584 12.7173L11.4536 23.739"
          stroke="#0C4261"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </Glyph>
  );
};

export default RainGlyph;
